import { useState } from 'react'

export const SHOW_LIMITS = [10, 25, 50] as const

export type ShowOption = (typeof SHOW_LIMITS)[number] | 'all'

// Only show useful limits. e.g. with 50 results, show 10 and 25, but not 50.
export const getShowOptions = (total: number): ShowOption[] => [
  ...SHOW_LIMITS.filter((limit) => limit < total),
  'all',
]

export const useChartDisplayRange = (total: number) => {
  const [showOption, setShowOption] = useState<ShowOption>(10)

  const showOptions = getShowOptions(total)
  const topN = showOption === 'all' ? total : showOption

  return {
    showOption,
    showOptions,
    setShowOption,
    topN,
  }
}
